import React from 'react';
import { LeadSingleSelectCell } from './LeadSingleSelectCell';
import { LeadMultiSelectCell } from './LeadMultiSelectCell';

export interface BaseSelectCellProps {
  value: any;
  options: any[];
  onChange: (newValue: any) => void;
  onAddOption?: (newOption: string) => Promise<void> | void;
  onActionClick?: () => void;
  actionText?: string;
  color?: 'primary' | 'default' | 'secondary' | 'error' | 'info' | 'success';
  placeholder?: string;
  menuWidth?: number;
  PaperProps?: any;
  MenuListProps?: any;
  emitStringValue?: boolean;
  sortOptions?: boolean;
}

export interface LeadSelectCellProps extends BaseSelectCellProps {
  multiple?: boolean;
}

export const LeadSelectCell: React.FC<LeadSelectCellProps> = ({
  multiple = false,
  ...props
}) => {
  if (multiple) {
    return <LeadMultiSelectCell {...props} />;
  }
  return <LeadSingleSelectCell {...props} />;
};

export default LeadSelectCell;
